import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SettlementAmountPerTreasuryDTO  {
    _originalTypeClassName = "zERP.BO.SettlementAmountPerTreasuryDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SettlementAmountPerTreasuryDTO.translate = translateService;
}
this.Amount = null;
this.SettlementAmountPerTreasuryDTOKey = null;
this._key = this.SettlementAmountPerTreasuryDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Amount:any;
Treasury:any;
private _SettlementAmountPerTreasuryDTOKey:any;
get SettlementAmountPerTreasuryDTOKey(): any {
    return this._SettlementAmountPerTreasuryDTOKey;
  }
set SettlementAmountPerTreasuryDTOKey(value: any) {
    this._SettlementAmountPerTreasuryDTOKey = value;
    this._key = value;
  }
static setTreasury = ($this, value) => {
var oldValue = $this.Treasury;
$this.Treasury = value;
if (value != null) {
}
}

static GetSummary(settlements: any): any{let summary = [];
for (let _isettlement = 0; _isettlement < (settlements == null ? 0 : settlements.length); _isettlement++) {let settlement = settlements[_isettlement];let settlementAmountPerTreasury = summary?.linq?.where((s) => CLMS.Framework.Number.Equal(() => s.Treasury.Id, () => settlement.TaxCategory.Treasury.Id))?.firstOrDefault(null);if (settlementAmountPerTreasury == null) {settlementAmountPerTreasury = new Domain.SettlementAmountPerTreasuryDTO();Domain.SettlementAmountPerTreasuryDTO.setTreasury(settlementAmountPerTreasury, settlement?.TaxCategory?.Treasury);settlementAmountPerTreasury.Amount = 0;summary?.add(settlementAmountPerTreasury);}settlementAmountPerTreasury.Amount = Joove.Common.safeNumber(settlementAmountPerTreasury?.Amount) + Joove.Common.safeNumber(settlement?.Amount);}
return summary;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SettlementAmountPerTreasuryDTOKey == null || $this.SettlementAmountPerTreasuryDTOKey == 0;
            }


}